<template>
  <v-container>
    <landing-create :content="content"></landing-create>
    <protocol-number-form
      v-if="protocolNumber"
      :isLoading="isLoading"
      :onSubmit="onSubmit"
      :protocolNumber="protocolNumber"
    ></protocol-number-form>
  </v-container>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import ProtocolNumberForm from './ProtocolNumberForm.vue';
import services from '../../../services';
import utilities from '../../../utilities';

const { ErrorMessageUtil } = utilities;
const { medicalRegistry } = services;
const { protocolNumberService } = medicalRegistry;

export default {
  name: 'ProtocolNumberUpdate',
  components: {
    LandingCreate,
    ProtocolNumberForm,
  },
  data: () => ({
    isLoading: false,
    content: {
      pageTitle: 'Project Code Update',
      enableBackButton: true,
    },
    protocolNumber: null,
  }),
  async created() {
    const { id } = this.$route.params;
    this.protocolNumber = await protocolNumberService.getOne({ id });
  },
  methods: {
    async onSubmit(data) {
      try {
        this.isLoading = true;
        const protocolNumber = await protocolNumberService.update({ protocolNumber: data });
        const { _id } = protocolNumber;
        /* eslint no-underscore-dangle: 0 */
        if (!data.otherDocuments?._id && data.otherDocuments) {
          const formData = new FormData();
          formData.append('attachment', data.otherDocuments[0]);
          await protocolNumberService.upload({ id: _id, formData });
        }
        this.isLoading = false;
        this.$snackbar.showOk({ text: 'Successfully updated project number!' });
        this.$router.push({ name: 'protocol-number.list' });
      } catch (e) {
        const error = e.response.data;
        this.$snackbar.showBad({
          text: ErrorMessageUtil.transform(error),
        });
      }
    },
  },
};
</script>
